var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.repos),function(repo){return _c('div',{key:repo.id},[_c('RepoItem',{attrs:{"repo":repo}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }